const messages = {
  bonus: {
    title: "Översikt över bonuskrediter",
    description: "Bonus i euro tilldelas deltagande företag baserat på inskickade försäljningssiffror.",
    lastMonth: "Förra månaden",
    currentMonth: "Nuvarande månad",
    totalCurrentYear: "Totalt innevarande år",
    totalLastYear: "Totalt förra året",
  },
  points: {
    title: "Översikt över poängkrediter",
    period: "Innevarande kalenderår ({year})",
    totalAwarded: "Totalt tilldelade poäng",
    redeemed: "Inlösta poäng",
    totalBalance: "Totalt poängsaldo",
    redemptionRate: "Inlösta poäng som procent av tilldelade poäng",
    averageAwarded: "Genomsnittligt tilldelade poäng per köpt däck",
    standardAwarded: "Nettopoäng från beräknade försäljningsrader, inklusive returer",
    bsPlusInclBooster: "Poäng från försäljningsrader med positiv kvantitet",
    perTire: "Inlösta poäng per köpt däck",
  },
  tires: {
    title: "Översikt över antal däck",
    description: "Däck köpta av kunderna",
    prevMonth: "Föregående månad",
    totalLastYear: "Totalt förra året",
    purchaseIndirect: "Köp via grossist (indirekt)",
    purchaseDirect: "Köp via grossist (direkt)",
    totalCurrentYear: "Totalt innevarande år",
    currentMonth: "Nuvarande månad",
  },
  participating: {
    title: "Översikt över deltagande kunder",
    description: "Företag som registrerar sig i BRIDGESTONE PLUS kan tilldelas via kundnumret.",
    total: "Totalt",
    newThisMonth: "Nya denna månad",
    newThisYear: "Nya i år",
    createdInCurrentMonth: "Skapade under innevarande månad (av admin)",
    loginsCurrentYear: "Inloggningar innevarande år (efter godkända villkor)",
  },
  brand: {
    title: "Varumärke",
    description: "Dina köp i detalj",
    centerTitle: "Per\nvarumärke",
  },
  rim: {
    title: "Fälg",
    centerTitle: "Per fälg\nstorlek",
  },
  tireGoals: {
    title: "Mål för däck",
    subtitle: "Tjäna poäng på dina däckköp.",
    centerTitle: "Per däck\nstorlek",
    tiresRemaining: "Återstående däck",
    progressionTarget: "Progressionsmål: ",
    pointsEarnedPurchases: "poäng intjänade\n" + "genom dina\n" + "köp",
    pointsEarnedBoosters: "poäng intjänade\n" + "genom\n" + "boosters",
    purchasesDetail: "Dina köp i detalj",
    cta: "Läs mer om dina poäng",
    pointsTitle: "Dina poäng",
    pointsSubtitle: "Poäng intjänade på dina Bridgestone-köp",
    achievementsTitle: "Dina prestationer",
    achievementsSubtitle: "Ditt årliga åtagande:",
    achievementsSubtitle2: "däck",
  },
  score: {
    title: "Poäng",
    total: "Totalt",
    credits: "Krediter i",
    deductions: "Avdrag i",
        unlockedPoints: "Upplåsta poäng",
        pendingPoints: "Väntande poäng",
  },
  score_extended: {
    title1: "Poängsaldo",
    title2: "Bonus i euro",
    balance: "Poängsaldo",
    bonus_in_euro: "Bonus i euro",
    date: "Datum",
    added_points: "Tillagda poäng i",
    total_bands: "Totalt antal varumärken",
    goal: "Mål",
    tyres_previous_year: "Däck sålda förra året",
    tyres_current_year: "Däck sålda i år",
    target_this_year: "Årets försäljningsmål",
    bonus_this_year: "Intjänad bonus (€)",
    loyal_minimum: "Lägsta lojalitetsnivå",
    bonus_multiplier: "Bonusmultiplikator",
  },
  lastImport: {
    label: "Senaste import av försäljningsdata:",
    on: "",
  },
  wholesalerTable: {
    title: "Deltagande kunder i detalj",
    description: "Nedan hittar du företag som har registrerat sig i BRIDGESTONE PLUS med din kundnummerkoppling. Du kan använda filtren för annan sortering eller sökfunktionen för att hitta kunder.",
    columns: {
      customer_number: "Kundnr",
      address_company_name: "Företag",
      address_street: "Gata och husnummer",
      address_postal_code: "Postnummer",
      address_city: "Stad",
      last_registration: "Senaste registrering",
      network: "Nätverk",
      profile_group: "Grupp",
      tires_amount: "Antal däck",
      point_balance: "Poängsaldo",
      bonus: "Bonus",
      details: "Detaljer",
    },
    searchPlaceholder: "Sök",
  },
  dealerTable: {
    columns: {
      date: "Datum",
      wholesaler_bs_plus: "Grossist BS+",
      customer_number: "Kundnummer",
      article: "Artikel",
      brand: "Varumärke",
      product: "Produkt",
      type: "Typ",
      inch: "Tum",
      season: "Säsong",
      amount: "Antal",
      points: "Poäng",
      activity: "Aktivitet",
      total_points: "Totala poäng",
    },
    title: "Dealertabell",
    description: "Översikt över dealeraktiviteter",
  },
  business_units: {
    title: "Affärsenheter",
    centerTitle: "Per\nenhet",
  },
  season: {
    title: "Säsong",
    centerTitle: "Per tid\npå året",
  },
};

export default {
  messages,
};
